import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import project from './app/project'
import notification from './app/notification'
import taskBoardNotification from './app/taskBoardNotification'
import chat from './app/chat'
import permissions from './app/permissions'
import tour from './app/tour'
import fm from './fm'
import socialCampaign from './app/socialCampaign'
import boards from './app/boards'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    project,
    notification,
    taskBoardNotification,
    chat,
    permissions,
    tour,
    fm,
    socialCampaign,
    boards,
  },
  strict: process.env.DEV,
})
